var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28411 22.2035C6.72462 22.2035 5.12303 23.0927 3.87769 24.8809C2.63026 26.672 1.9 29.1535 1.9 31.7845C1.9 33.019 2.24391 34.1611 2.80363 34.9649C3.36127 35.7656 4.03013 36.1 4.61705 36.1H26.6194C27.2063 36.1 27.8752 35.7656 28.4328 34.9649C28.9925 34.1611 29.3364 33.019 29.3364 31.7845C29.3364 29.1535 28.6062 26.672 27.3587 24.8809C26.1134 23.0927 24.5118 22.2035 22.9523 22.2035H8.28411ZM2.31853 23.795C3.82402 21.6333 5.95334 20.3035 8.28411 20.3035H22.9523C25.2831 20.3035 27.4124 21.6333 28.9179 23.795C30.4213 25.9537 31.2364 28.8295 31.2364 31.7845C31.2364 33.343 30.8076 34.8795 29.992 36.0507C29.1742 37.2249 27.9776 38 26.6194 38H4.61705C3.25885 38 2.06225 37.2249 1.24448 36.0507C0.428794 34.8795 0 33.343 0 31.7845C0 28.8295 0.815143 25.9537 2.31853 23.795Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6182 1.9C11.7029 1.9 8.52891 5.07399 8.52891 8.98931C8.52891 12.9046 11.7029 16.0786 15.6182 16.0786C19.5335 16.0786 22.7075 12.9046 22.7075 8.98931C22.7075 5.07399 19.5335 1.9 15.6182 1.9ZM6.62891 8.98931C6.62891 4.02465 10.6536 0 15.6182 0C20.5829 0 24.6075 4.02465 24.6075 8.98931C24.6075 13.954 20.5829 17.9786 15.6182 17.9786C10.6536 17.9786 6.62891 13.954 6.62891 8.98931Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.0a1346b36614c49e24233a0f4d946660.svg";
export { ForwardRef as ReactComponent };